const h = {
  title: 'SmallStep',
  languageText: '简体中文',
  subTitle: '应用出海服务厂商',
  lTitle: '开放务实',
  cTitle: '用户导向',
  rTitle: '全球化视野',
  mode1: '公司简介',
  mode2: '公司产品',
  mode4: '联系我们',
  p1: 'Smallstep 小步科技成立于2019年7月，致力于应用出海、移动广告投放与变现，为全球用户提供优质产品和服务。 产品业务线覆盖港澳台、东南亚、欧美等多个地区，累计用户超5000W。',
  p2: '小步始终保持初心，用开放务实的心态面对用户，以较高的市场敏锐度和行业发展前瞻性，持续探索和创新，精细化打磨产品，旨在将更极致的产品和服务带给全球用户。',
  desc1: '丰富的海外产品经验',
  desc2: '富有创造力的年轻化团队',
  desc3: '丰富的渠道资源',
  desc4: '注重用户体验和员工成长',
  benefitsTitle1: '生活保障',
  benefitsTitle2: '福利待遇',
  benefitsTitle3: '娱乐活动',
  benefits1Desc1: '弹性上班制',
  benefits1Desc2: '周末双休',
  benefits1Desc3: '五险一金',
  benefits1Desc4: '年度体检',
  benefits2Desc1: '年终奖',
  benefits2Desc2: '项目奖金',
  benefits2Desc3: '调薪机会',
  benefits2Desc4: '带薪年假',
  benefits3Desc1: '零食下午茶',
  benefits3Desc2: '年度旅游',
  benefits3Desc3: '日常团建',
  benefits3Desc4: '节日福利 生日礼品',
  usTitle1: '公司地址',
  usTitle2: '交通方式',
  usTitle3: '加入我们',
  usDesc1: '广东省广州市海珠区昌岗街道达镖国际中心1908',
  usDesc2: '地铁2/8号线昌岗地铁E/F出口',
  usDesc3: 'hr@smallstepinfo.com',
  home: '首页',
  policy: '隐私政策',
  service: '用户协议',
  beian1: '备案号: 粤ICP备19148330号',
  beian2: '广州市小步信息科技有限公司'
};

export default h;
